import React from "react"

import AdminHeaderNavigation from "../../components/AdminComponents/Dashboard/Navigation"

function AdminDashboardPage(){
    return (
      <div>
        {/* <NavBar /> */}
  
        {/* <AdminCustomersLeft /> */}
        <AdminHeaderNavigation />
        {/* <footer /> */}
      </div>
    )
  }
  
  export default AdminDashboardPage;